import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history', //微信分享问题
  base: '/m/',
  routes: [{
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../pages/Home/TG_Home.vue'), //路由懒加载,
      meta: {
        keepAlive: true, //是否缓存
      }
    },
    // 公告
    {
      path: '/notice',
      name: 'notice',
      component: () => import('../pages/Notice/TG_Notice_detail') //路由懒加载,
    },
    // 资讯
    {
      path: '/news',
      name: 'news',
      component: () => import('../pages/News/TG_News_list'),
      meta: {
        keepAlive: true, //是否缓存
      }
    },
    // 宣传
    {
      path: '/publicity',
      name: 'publicity',
      component: () => import('../pages/publicity/publicity')
    },
    {
      path: "/newsdetail",
      name: 'newsdetail',
      component: () => import('../pages/News/TG_News_detail')
    },
    // 活动
    {
      path: "/activity",
      name: 'activity',
      component: () => import('../pages/Activity/TG_Activity_list'),
      meta: {
        keepAlive: true,
      }
    },
    {
      path: "/activitydetail/:id",
      name: 'activitydetail',
      component: () => import('../pages/Activity/TG_Activity_detail'),
    },
    // 乐队天地
    {
      path: "/band",
      name: 'band',
      component: () => import('../pages/Band/TG_Band_list.vue'),
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/banddetail',
      name: 'banddetail',
      component: () => import('../pages/Band/TG_Band_detail')
    },
    // 乐队天地  资讯详情
    {
      path: '/bandaction',
      component: () => import('../pages/Band/TG_Band_detail_action.vue')
    },
    // 学者
    {
      path: '/experts',
      component: () => import('../pages/Experts/TG_Experts')
    },
    {
      path: '/expertslist/musicianType',
      name: 'musicianType',
      component: () => import('../pages/Experts/TG_Experts_List')
    },
    // 星光
    {
      path: '/star',
      component: () => import('../pages/Star/TG_Star_list')
    },
    {
      path: '/star/stardetail/:id',
      component: () => import('../pages/Star/TG_Star_detail')
    },
    // 星光点赞登录
    {
      path: '/wxlogin',
      component: () => import('../pages/login/wxlogin')
    },
    // 音乐汇
    {
      path: '/musicscore',
      name: 'musicscore',
      component: () => import('../pages/Music/TG_Music_list'),
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/musicscore/musicdetail',
      name: 'musicdetail',
      component: () => import('../pages/Music/TG_Music_detail')
    },
    // 知识汇
    {
      path: '/knowledge',
      name: 'knowledge',
      component: () => import('../pages/Knowledge/TG_Knowledge_list'),
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/knowledge/Knowledgedetail',
      name: 'Knowledgedetail',
      component: () => import('../pages/Knowledge/TG_Knowledge_detail')
    },
    // 各地省站
    {
      path: '/province',
      component: () => import('../pages/Province/TG_Province_list')
    },
    // 省站咨询
    {
      path: '/provinceNews',
      component: () => import('../pages/Province/news_list')
    },
    // 省站咨询详情
    {
      path: '/provinceNewDetail',
      component: () => import('../pages/Province/news_detail')
    },
    // 音乐欣赏
    {
      path: '/appreciation',
      component: () => import('../pages/Music_Appreciation/TG_Appreciation_list')
    },
    //师资认证列表
    {
      path: '/teacherList',
      name: 'teacherList',
      component: () => import('../pages/teacher/TG_teacher_list'),
      meta: {
        keepAlive: true, //是否缓存
      }
    },
    //师资详请
    {
      path: '/teacherdetail',
      name: 'teacherDetail',
      component: () => import('../pages/teacher/TG_teacher_detail'),
      // meta:{ 
      //   keepAlive:false,//是否缓存
      //   isBack:false,//用于判断上个页面从哪过来的
      // }
    },
    //人才招募
    {
      path: '/recruitList',
      name: 'recruit',
      component: () => import('../pages/Recruit/Recruit_list.vue')
    },
    ,
    {
      path: '/transfer',
      name: 'transfer',
      component: () => import('../pages/Transfer/iframe.vue'),
      meta: {
        normal: false
      }

    }
    ,
    //找不到页面
    {
      path: '*',
      name: 'notfount',
      component: () => import('../pages/404/404.vue')

    }

  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js